module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.scss
// module id = ./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.scss
// module chunks = 0